// src/App.js
import React, { useState } from "react";
import TitleInput from "./components/RugForm/TitleInput";
import DescriptionInput from "./components/RugForm/DescInput";
import ColorCountInput from "./components/RugForm/ColorInput";
import RugGrid from "./components/RugGrid/RugGrid";
import './App.css';
import logo from './tuftEnuff-logo5.1T.png'; 

function App() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [colorCount, setColorCount] = useState(1);
  const [grid, setGrid] = useState(Array(4).fill(Array(6).fill(false))); 

  const toggleSquare = (x, y) => {
    setGrid((prevGrid) =>
      prevGrid.map((row, rowIndex) =>
        row.map((col, colIndex) =>
          rowIndex === x && colIndex === y ? !col : col
        )
      )
    );
  };

  const totalCost = colorCount * 7 + grid.flat().filter((sq) => sq).length * 20;

  return (
    <div className="container">
      <div className="form-header">
        <img src={logo} alt="Logo" className="logo" /> 
        <h1>Custom Rug Form</h1> 
      </div>
      <div className="form-container">
        <TitleInput title={title} setTitle={setTitle} />
        <DescriptionInput description={description} setDescription={setDescription} />
        <ColorCountInput colorCount={colorCount} setColorCount={setColorCount} />
      </div>
      <div className="rug-grid-container">
        <RugGrid grid={grid} toggleSquare={toggleSquare} />
      </div>

      <div className="total-cost">Total Cost: ${totalCost}</div>
    </div>
  );
}

export default App;
